/* eslint-disable react/prop-types */
import React, { useImperativeHandle, forwardRef, useState, useRef } from 'react';
import TransformableShape from './TransformableShape';

// eslint-disable-next-line react/prop-types, react/display-name
const SoundShape = forwardRef((props, _ref) => {
  const shapeRef = useRef();

  const [note] = useState(props.note);
  const [normFreq, setNormFreq] = useState(props.normFreq);
  const [color] = useState(props.shapeProps.fill);
  const [texture] = useState(props.shapeProps.texture);
  const [isPlaying, setIsPlaying] = useState(false);
  const [amplitude, setAmplitude] = useState(props.amplitude);

  const id = props.shapeProps.id;
  // const [shape] = useState(props.shape);

  useImperativeHandle(_ref, () => ({

    getId: () => {
      return id;
    },

    getX: () => {
      return shapeRef.current.getBoundingBox().x;
    },

    getY: () => {
      return shapeRef.current.getBoundingBox().y;
    },

    getHeight: () => {
      return shapeRef.current.getBoundingBox().height;
    },

    getWidth: () => {
      return shapeRef.current.getBoundingBox().width;
    },

    getTexture: () => {
      return texture; // TODO: change to bounding box
    },

    getColor: () => {
      return color;
    },

    getNote: () => {
      return note;
    },

    getNormFreq: () => {
      return normFreq;
    },

    getIsPlaying: () => {
      return isPlaying;
    },

    setIsPlaying: (isPlaying) => {
      setIsPlaying(isPlaying);
    },

    setAmplitude: (amplitude) => {
      setAmplitude(amplitude);
      props.onAmplitudeChange(amplitude);
    },

    setNormFreq: (normFreq) => {
      setNormFreq(normFreq);
      props.onNormFreqChange(normFreq);
    },

    getAmplitude: () => {
      return amplitude;
    }
  }));

  // useEffect(() => {
  //   if (props.isSelected) {
  //   // we need to attach transformer manually
  //     trRef.current.nodes([shapeRef.current.getShapeRef().current]);
  //     trRef.current.getLayer().batchDraw();
  //   // console.log('selected shape: ' + this.state.id);
  //   };
  // }, [props.isSelected]);

  function handleClick (e) {
    props.onSelect();
    // props.onClick();
  };

  return (
      <React.Fragment>
      <TransformableShape
        {...props.shapeProps}
          type={props.shapeProps.shape}
          ref={shapeRef}
          isSelected={props.isSelected}
          onClick={handleClick}
          onChange={props.onChange}

      />
      </React.Fragment>
  );
  ;

  // </React.Fragment>
  // );
});

export default React.memo(SoundShape);
